/**
 * OSS 媒体 img 按需预签名（v-oss-src）。最后更新：2026-07-01
 */
import Vue from 'vue'
import { resolveDisplayMediaUrl, resolveMediaUrl } from '../utils/mediaUrl'
import { getUploadSchoolId } from '../utils/ossMediaUpload'

function refreshViewer(el) {
  Vue.nextTick(() => {
    const targets = [el, el.parentElement].filter(Boolean)
    targets.forEach((node) => {
      if (node.$viewer && typeof node.$viewer.update === 'function') {
        node.$viewer.update()
      }
    })
  })
}

async function applyOssSrc(el, path, vm, schoolId) {
  const p = path == null ? '' : String(path).trim()
  if (!p) {
    el.removeAttribute('src')
    return
  }
  const sid = schoolId || getUploadSchoolId(vm)
  try {
    el.src = await resolveDisplayMediaUrl(p, sid, { inline: true })
  } catch (e) {
    console.warn('[v-oss-src]', e)
    el.src = resolveMediaUrl(p)
  }
  refreshViewer(el)
}

export default {
  bind(el, binding, vnode) {
    const schoolId = binding.arg || (binding.value && binding.value.schoolId)
    const path = binding.value && typeof binding.value === 'object' ? binding.value.src : binding.value
    applyOssSrc(el, path, vnode.context, schoolId)
  },
  update(el, binding, vnode) {
    const schoolId = binding.arg || (binding.value && binding.value.schoolId)
    const path = binding.value && typeof binding.value === 'object' ? binding.value.src : binding.value
    const oldPath = binding.oldValue && typeof binding.oldValue === 'object' ? binding.oldValue.src : binding.oldValue
    if (path !== oldPath) {
      applyOssSrc(el, path, vnode.context, schoolId)
    }
  },
}
